import * as index from '@syncfusion/ej2-schedule';
index.Schedule.Inject( index.Day,index.Week,index.WorkWeek,index.Month,index.Agenda,index.MonthAgenda,index.TimelineViews,index.TimelineMonth,index.Resize,index.DragAndDrop,index.ExcelExport,index.ICalendarExport,index.ICalendarImport,index.Print);
export * from '@syncfusion/ej2-schedule';
